var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08398 10.0007C2.08398 6.2687 2.08398 4.40273 3.24335 3.24335C4.40273 2.08398 6.2687 2.08398 10.0007 2.08398C13.7326 2.08398 15.5986 2.08398 16.758 3.24335C17.9173 4.40273 17.9173 6.2687 17.9173 10.0007C17.9173 13.7326 17.9173 15.5986 16.758 16.758C15.5986 17.9173 13.7326 17.9173 10.0007 17.9173C6.2687 17.9173 4.40273 17.9173 3.24335 16.758C2.08398 15.5986 2.08398 13.7326 2.08398 10.0007Z",
    stroke: "currentColor",
    strokeWidth: 0.833333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 10.4167L8.74935 12.5L13.3327 7.5",
    stroke: "currentColor",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkChecked);
export default __webpack_public_path__ + "static/media/checkmark_checked.74e346252cf688c8430234d6643ea9a5.svg";
export { ForwardRef as ReactComponent };